import {
  MARK_ASPECT,
  MARK_KNOCKOUT_PATH,
  MARK_MIN_STROKE,
  MARK_NAVY,
  MARK_SOLID_PATH,
  MARK_STROKE_RATIO,
  MARK_VIEWBOX,
  MARK_WHITE,
} from './markPath'

interface LogoMarkProps {
  /** The mark's width. It is wider than it is tall, so the height follows from MARK_ASPECT. */
  size?: number
  /** The ink: the solid ring and both outlines. Navy on a light surface, white on a dark one. */
  color?: string
  /**
   * What the crossing ring is filled with, which has to be the surface the mark sits on. On a
   * surface of the same colour that ring is nothing but its outline, which is the point: the two
   * rings read as overlapping because one of them is the background showing through the other.
   */
  background?: string
  className?: string
}

/**
 * The FrontFlow mark.
 *
 * The outline is held at MARK_MIN_STROKE or above, so it never falls below a whole pixel and
 * disappears. Above roughly 50px the drawn 2% takes over and the mark is the source exactly.
 */
export function LogoMark({
  size = 32,
  color = MARK_NAVY,
  background = MARK_WHITE,
  className,
}: LogoMarkProps) {
  const strokeWidth = Math.max(MARK_MIN_STROKE, size * MARK_STROKE_RATIO)

  return (
    <svg
      width={size}
      height={size * MARK_ASPECT}
      viewBox={MARK_VIEWBOX}
      aria-hidden="true"
      className={className}
    >
      {/* vectorEffect is not inherited, so it goes on each path. On the group it is silently
          ignored, and strokeWidth is then read as user units in a ~996-wide viewBox: at 32px
          that is 0.06 of a pixel, which is how the outline came to vanish entirely. */}
      <g stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round">
        <path d={MARK_SOLID_PATH} fill={color} vectorEffect="non-scaling-stroke" />
        <path d={MARK_KNOCKOUT_PATH} fill={background} vectorEffect="non-scaling-stroke" />
      </g>
    </svg>
  )
}
